function GuestList() {
    return (
      <>
        <div className="font-bold text-lg mb-16">GuestList</div>
      </>
    );
  }
  
  export default GuestList;